import type { Middleware, ResponseContext } from '@dynamic-labs/sdk-api-core';

import { UnauthorizedError } from '../../../../errors/UnauthorizedError';

/** @notInstrumented */
export const createUnauthorizedMiddleware = (): Middleware => ({
  post: async (context: ResponseContext) => {
    if (context.response.status === 401) {
      let cause: Error | null = null;

      try {
        const errorBody = await context.response.clone().json();

        if (
          errorBody &&
          'error' in errorBody &&
          typeof errorBody.error === 'string'
        ) {
          // eslint-disable-next-line no-restricted-syntax
          cause = new Error(errorBody.error);
        }
      } catch {
        // Response body isn't valid JSON — proceed without a cause
      }

      throw new UnauthorizedError({ cause });
    }

    return context.response;
  },
});
